// msal-config.ts
import { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: '17d1195f-753e-46b7-8509-67e5cbc733c9', // Replace with your Azure AD app registration client ID
    authority: 'https://login.microsoftonline.com/common/v2.0',
//    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
};

export const loginRequest: PopupRequest = {
  scopes: [
    'api://17d1195f-753e-46b7-8509-67e5cbc733c9/access_as_user',
    'openid',
    'profile',
    'offline_access'
  ]
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};